import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface StatTileProps {
  label: string;
  value: string;
  /** Conținut suplimentar sub valoare (ex. o bară de nivel). */
  children?: ReactNode;
}

/** Celula mică din interiorul cardurilor: fundalul paginii, colț 18px. */
export function StatTile({ label, value, children }: StatTileProps) {
  return (
    <Box
      sx={(theme) => ({
        borderRadius: `${theme.radii.tile}px`,
        backgroundColor: theme.palette.weather.bg,
        padding: '15px 17px',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        transition: 'background-color .5s ease',
      })}
    >
      <Typography
        component="span"
        sx={(theme) => ({ fontSize: 12, fontWeight: 500, color: theme.palette.weather.faint })}
      >
        {label}
      </Typography>
      <Typography component="span" sx={{ fontSize: 18, fontWeight: 500 }}>
        {value}
      </Typography>
      {children}
    </Box>
  );
}
